const Svg = ({ children, className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    {children}
  </svg>
);

export const LobbySportIcon = ({ name, className = "w777-sport-glyph" }) => {
  switch (name) {
    case "crash":
      return (
        <Svg className={className}>
          <path d="M3 13.5 11 8l2.2 1.2L21 5l-1.2 8.2L14 16l-2.5-1.4L5 18.5l-2-5z" />
        </Svg>
      );
    case "lottery":
      return (
        <Svg className={className}>
          <path d="M6 4h12v3H6V4zm0 5h12v11H6V9zm3 3v2h6v-2H9zm0 4v2h6v-2H9z" />
        </Svg>
      );
    case "exchange":
      return (
        <Svg className={className}>
          <path d="M4 7h11v2H7.4l2.3 2.3-1.4 1.4L4 10V7zm16 10H9v-2h7.6l-2.3-2.3 1.4-1.4L20 14v3z" />
        </Svg>
      );
    case "casino":
      return (
        <Svg className={className}>
          <path d="M5 5h14v4H5V5zm2 6h10v8H7v-8zm2 2v4h6v-4H9z" />
        </Svg>
      );
    case "slot":
      return (
        <Svg className={className}>
          <path d="M4 6h16v12H4V6zm3 2v2h2V8H7zm4 0v2h2V8h-2zm4 0v2h2V8h-2zM7 12v2h2v-2H7zm4 0v2h2v-2h-2zm4 0v2h2v-2h-2z" />
        </Svg>
      );
    case "fantasy":
      return (
        <Svg className={className}>
          <path d="M8 6h8a2 2 0 0 1 2 2v3h2v2h-2v5H6v-5H4v-2h2V8a2 2 0 0 1 2-2zm1 4h6V8H9v2z" />
        </Svg>
      );
    case "cricket":
      return (
        <Svg className={className}>
          <path d="M5 19 16 8l3 3L8 22 5 19zm12.8-9.9 1.1-1.1a1 1 0 0 0 0-1.4l-1.5-1.5a1 1 0 0 0-1.4 0l-1.1 1.1 2.9 2.9zM7 6a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" />
        </Svg>
      );
    case "football":
      return (
        <Svg className={className}>
          <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1.2 4.3 2.4 1.4-1 1.7-2.4-1.4 1-1.7zm-3.1 2.2 2.4 1.4-1 1.7-2.4-1.4 1-1.7zm6.6 0 1 1.7-2.4 1.4-1-1.7 2.4-1.4zm-3.3 4.1 2.4 1.4-1 1.7-2.4-1.4 1-1.7z" />
        </Svg>
      );
    case "tennis":
      return (
        <Svg className={className}>
          <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 3a7 7 0 0 1 4.2 12.2 7 7 0 0 1-8.4 0A7 7 0 0 1 12 5z" />
        </Svg>
      );
    case "table-tennis":
      return (
        <Svg className={className}>
          <path d="M4 5h9a5 5 0 0 1 5 5v1h2v2h-2v2H8a5 5 0 0 1-5-5V5zm2 2v1a3 3 0 0 0 3 3h8.1A3 3 0 0 0 13 7H6zm12.5 9.5 2 2-1.4 1.4-2-2 1.4-1.4z" />
        </Svg>
      );
    case "esoccer":
      return (
        <Svg className={className}>
          <path d="M8 6h8a2 2 0 0 1 2 2v3h2v2h-2v5H6v-5H4v-2h2V8a2 2 0 0 1 2-2zm1 4h6V8H9v2z" />
        </Svg>
      );
    case "badminton":
      return (
        <Svg className={className}>
          <path d="m6 18 2-2 1.5 1.5-2 2-1.5-1.5zm10.8-11.3 1.1-1.1a1 1 0 0 0 0-1.4l-1.5-1.5a1 1 0 0 0-1.4 0l-1.1 1.1 2.9 2.9zM7 6a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" />
        </Svg>
      );
    case "horse":
      return (
        <Svg className={className}>
          <path d="M4 16c2-4 4-6 7-7l1-3 2 1v3c3 1 5 3 6 6l-2 1c-1-2-2-3-4-4v5H9v-4c-2 1-3 2-4 4l-1-2z" />
        </Svg>
      );
    case "dog":
      return (
        <Svg className={className}>
          <path d="M5 14c1-3 3-5 6-5l1-2h2l1 2c2 0 4 2 5 5h-2c-1-2-2-3-4-3v5H9v-4c-1 1-2 2-3 4H5z" />
        </Svg>
      );
    case "politics":
      return (
        <Svg className={className}>
          <path d="M4 18h16v2H4v-2zm2-2h3V9H6v7zm5 0h3V6h-3v10zm5 0h3v-4h-3v4zM11 4h2l5 3H6l5-3z" />
        </Svg>
      );
    case "basketball":
      return (
        <Svg className={className}>
          <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 2c1.5 0 2.9.4 4.1 1.1C14.7 6.4 13.4 8 12.5 10H12V4zm-2 0v6c-.9-2-2.2-3.6-3.6-4.9A8 8 0 0 1 10 4zm8.9 3.1A8 8 0 0 1 20 12c0 1.4-.4 2.8-1 4H14c.7-2 1.2-4.2 1.2-6.5 0-.8 0-1.6-.1-2.4zM4 12c0-1.4.4-2.8 1-4h5c-.7 2-1.2 4.2-1.2 6.5 0 .8 0 1.6.1 2.4A8 8 0 0 1 4 12zm6 8v-6h.5c.9 2 2.2 3.6 3.6 4.9A8 8 0 0 1 10 20zm2 0c-1.5 0-2.9-.4-4.1-1.1C9.3 17.6 10.6 16 11.5 14H12v6z" />
        </Svg>
      );
    case "volleyball":
      return (
        <Svg className={className}>
          <path d="M12 2a10 10 0 1 0 .01 20A10 10 0 0 0 12 2zm0 2c1.7 0 3.3.5 4.6 1.4L12 8.5 7.4 5.4A8 8 0 0 1 12 4zm-6.5 3.2L10 10.5v5.2L5.5 18A8 8 0 0 1 5.5 7.2zM14 10.5l4.5-3.3A8 8 0 0 1 18.5 18L14 15.7v-5.2zM12 18.5l3.5-2.2L12 14l-3.5 2.3L12 18.5z" />
        </Svg>
      );
    case "snooker":
      return (
        <Svg className={className}>
          <circle cx="12" cy="12" r="8" />
          <circle cx="12" cy="12" r="2.5" fill="#111" />
        </Svg>
      );
    case "hockey":
      return (
        <Svg className={className}>
          <path d="M5 18h5l1-3 7-9 2 1-7 10-1 3H5v-2zm12-1a2 2 0 1 1 0 4 2 2 0 0 1 0-4z" />
        </Svg>
      );
    case "egames":
      return (
        <Svg className={className}>
          <path d="M6 8h12a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3zm2 2v1h2v-1H8zm6 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm2.5 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM7 13h4v1H7v-1z" />
        </Svg>
      );
    case "handball":
      return (
        <Svg className={className}>
          <path d="M12 2a6 6 0 0 1 4 10c0 2-1 3-2 4v4h-4v-4c-1-1-2-2-2-4a6 6 0 0 1 4-10zm0 2a4 4 0 0 0 0 8 4 4 0 0 0 0-8z" />
        </Svg>
      );
    default:
      return (
        <Svg className={className}>
          <circle cx="12" cy="12" r="8" />
        </Svg>
      );
  }
};

export const QUICK_TAB_ITEMS = [
  { label: "Sports Crash", icon: "crash" },
  { label: "Lottery", icon: "lottery" },
  { label: "Exchange", icon: "exchange" },
  { label: "Live Casino", icon: "casino" },
  { label: "Slot", icon: "slot" },
  { label: "Fantasy Games", icon: "fantasy" },
];

export const TOP_NAV_ITEMS = [
  { label: "Crash", icon: "crash" },
  { label: "Sports Book", icon: "football" },
  { label: "Lottery", icon: "lottery" },
  { label: "Exchange", icon: "exchange", active: true },
  { label: "Live Casino", icon: "casino" },
  { label: "Slot", icon: "slot" },
  { label: "Fantasy Games", icon: "fantasy" },
];

export const SPORT_STRIP_ITEMS = [
  { label: "Cricket", icon: "cricket", sportId: 4 },
  { label: "Football", icon: "football", sportId: 1 },
  { label: "Tennis", icon: "tennis", sportId: 2 },
  { label: "Table Tennis", icon: "table-tennis", sportId: null },
  { label: "Esoccer", icon: "esoccer", sportId: null },
  { label: "Badminton", icon: "badminton", sportId: null },
];

export const RACING_SPORTS = [
  { label: "Horse Racing", icon: "horse", tone: "orange" },
  { label: "Greyhound Racing", icon: "dog", tone: "grey" },
];

export const ALL_SPORTS_MENU = [
  { label: "Politics", count: 1, icon: "politics", tone: "orange" },
  { label: "Cricket", count: 21, icon: "cricket", sportId: 4, tone: "blue" },
  { label: "Football", count: 156, icon: "football", sportId: 1, tone: "green" },
  { label: "Tennis", count: 100, icon: "tennis", sportId: 2, tone: "orange" },
  { label: "Table Tennis", count: 211, icon: "table-tennis", tone: "red" },
  { label: "Badminton", count: 4, icon: "badminton", tone: "green" },
  { label: "Esoccer", count: 20, icon: "esoccer", tone: "teal" },
  { label: "Basketball", count: 99, icon: "basketball", tone: "orange" },
  { label: "Volleyball", count: 21, icon: "volleyball", tone: "teal" },
  { label: "Snooker", count: 0, icon: "snooker", tone: "green" },
  { label: "Ice Hockey", count: 14, icon: "hockey", tone: "blue" },
  { label: "E Games", count: 4, icon: "egames", tone: "purple" },
  { label: "Futsal", count: 0, icon: "football", tone: "green" },
  { label: "Handball", count: 0, icon: "handball", tone: "purple" },
  { label: "Baseball", count: 8, icon: "cricket", tone: "red" },
  { label: "Kabaddi", count: 3, icon: "fantasy", tone: "orange" },
];

export const FEATURED_EVENTS = [
  { label: "FIFA WORLD CUP - WINNER 2026", icon: "football", tone: "sport-football" },
  { label: "England v India", icon: "cricket", tone: "sport-cricket" },
  { label: "FIFA WORLD CUP 2026 - SPECIAL", icon: "football", tone: "sport-football" },
];
